/**
 * The configuration schema contract and browser rule evaluator of the Custom App SDK, which the property-model form
 * shares with Custom Apps so that both evaluate rules the same way. Only types are imported statically; the evaluator
 * and its CEL engine load with the first property-model configurator, as the SDK loads them with the first schema.
 */
export type {
	PartConfigurationChildEvaluation,
	PartConfigurationCurrentInput,
	PartConfigurationDocumentValue,
	PartConfigurationEvaluation,
	PartConfigurationPropertyEvaluation,
	PartConfigurationSchema,
	PartConfigurationSchemaOption,
	PartConfigurationSchemaProperty,
	PartConfigurationSchemaValidationIssue,
	PartConfigurationSubConfigurationValue,
	PartConfigurationTarget,
	PartConfigurationTreePathElement,
	PartConfigurationValue,
} from "@customAppSdk/aavo-sdk.ts";

export type PartConfigurationEvaluatorModule = typeof import("@customAppSdk/partConfigurationEvaluator.ts");

/** Evaluates a schema's rules for input values, synchronously, once the rule engine is prepared for the schema. */
export type EvaluatePartConfiguration = PartConfigurationEvaluatorModule["evaluatePartConfiguration"];

export async function loadPartConfigurationEvaluator(): Promise<PartConfigurationEvaluatorModule> {
	return await import("@customAppSdk/partConfigurationEvaluator.ts");
}
